import styled from 'styled-components';
import { theme } from './theme';

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: ${theme.colors.background};
  color: ${theme.colors.text};
  font-family: ${theme.fonts.main};
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  background: ${theme.gradients.primary};
  box-shadow: ${theme.shadows.medium};
`;

export const Logo = styled.h1`
  margin: 0;
  font-size: 2rem;
  font-weight: bold;
  color: ${theme.colors.text};
  font-family: 'Pacifico', cursive, ${theme.fonts.main};
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 1px;
  
  /* Add a subtle animation on hover */
  &:hover {
    transform: scale(1.05);
    transition: transform 0.3s ease;
  }
`;

export const ServiceSelector = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
`;

export const Select = styled.select`
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.small};
  background-color: ${theme.colors.backgroundLight};
  color: ${theme.colors.text};
  border: 1px solid ${theme.colors.border};
  outline: none;
  
  &:focus {
    border-color: ${theme.colors.primary};
  }
`;

export const ChatContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.md};
  overflow: hidden;
`;

export const MessagesContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${theme.spacing.md} 0;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: ${theme.colors.backgroundLight};
    border-radius: ${theme.borderRadius.small};
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.secondary};
    border-radius: ${theme.borderRadius.small};
  }
`;

export const MessageBubble = styled.div<{ isUser: boolean }>`
  max-width: 70%;
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.medium};
  background-color: ${props => props.isUser ? theme.colors.primary : theme.colors.secondary};
  align-self: ${props => props.isUser ? 'flex-end' : 'flex-start'};
  box-shadow: ${theme.shadows.small};
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    ${props => props.isUser ? 'right' : 'left'}: -10px;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-top-color: ${props => props.isUser ? theme.colors.primary : theme.colors.secondary};
    border-bottom: 0;
    margin-bottom: -10px;
  }
`;

export const MessageText = styled.p`
  margin: 0;
  line-height: 1.5;
  color: ${theme.colors.text};
`;

export const MessageTime = styled.span`
  font-size: 0.7rem;
  color: ${theme.colors.textSecondary};
  margin-top: ${theme.spacing.xs};
  display: block;
  text-align: right;
`;

export const InputContainer = styled.form`
  display: flex;
  gap: ${theme.spacing.sm};
  padding: ${theme.spacing.md};
  background-color: ${theme.colors.backgroundLight};
  border-radius: ${theme.borderRadius.medium};
  margin-top: ${theme.spacing.md};
`;

export const Input = styled.input`
  flex: 1;
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.small};
  border: 1px solid ${theme.colors.border};
  background-color: ${theme.colors.background};
  color: ${theme.colors.text};
  outline: none;
  
  &:focus {
    border-color: ${theme.colors.primary};
  }
`;

export const SendButton = styled.button`
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.small};
  background: ${theme.gradients.primary};
  color: ${theme.colors.text};
  border: none;
  cursor: pointer;
  transition: all ${theme.transitions.fast};
  
  &:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LoadingIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.md};
  
  .dot {
    width: 8px;
    height: 8px;
    background-color: ${theme.colors.accent};
    border-radius: 50%;
    margin: 0 4px;
    animation: bounce 1.5s infinite ease-in-out;
  }
  
  .dot:nth-child(1) {
    animation-delay: 0s;
  }
  
  .dot:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  .dot:nth-child(3) {
    animation-delay: 0.4s;
  }
  
  @keyframes bounce {
    0%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
  }
`;

export const ServiceTag = styled.span`
  font-size: 0.7rem;
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  background-color: ${theme.colors.accent};
  color: ${theme.colors.background};
  border-radius: ${theme.borderRadius.small};
  margin-left: ${theme.spacing.sm};
`;

export const ErrorMessage = styled.div`
  padding: ${theme.spacing.md};
  background-color: ${theme.colors.error};
  color: ${theme.colors.text};
  border-radius: ${theme.borderRadius.medium};
  margin: ${theme.spacing.md} 0;
  text-align: center;
`; 